export const messages = {
  en: {
    reportHuaning: {
      search: {
        title: 'Search Conditions',
        feeType: 'Please select fee type',
        floor: 'Please select floor'
      },
      tab: {
        oweFee: 'Uncollected Situation Report',
        oweFeeDetail: 'Uncollected Details Report',
        payFee: 'Current Month Collection Report'
      }
    },
    reportHuaningOweFee: {
      table: {
        floorNum: 'Building Number',
        totalOweAmount: 'Total Uncollected Amount (as of {date})',
        shortAmount: 'Short-Collected Amount',
        oweAmount: 'Uncollected Amount',
        preYearOweAmount: 'Uncollected Amount Before'
      }
    },
    reportHuaningPayFee: {
      table: {
        floorNum: 'Building Number',
        monthlyReceivable: 'Monthly Receivable',
        monthReceived: 'Month Received',
        monthReceivedPart1: 'Month Received belongs to {year} Year 1-{month} Month Part',
        monthReceivedPart2: 'Month Received belongs to {year} Year {month} Month Part',
        monthReceivedPart3: 'Month Received belongs to {nextMonth} Pre-collection Part',
        monthReceivedPart4: 'Month Received belongs to Before {year} Year Part'
      }
    },
    reportHuaningOweFeeDetail: {
      table: {
        roomNum: 'Room Number',
        area: 'Area',
        fee: 'Fee',
        startTime: 'Fee Start Time',
        endTime: 'Fee End Time',
        totalOweAmount: 'Total Uncollected Amount',
        shortAmount: 'Short-Collected Amount',
        oweAmount: 'Uncollected Amount',
        preYearOweAmount: 'Uncollected Amount Before'
      }
    },
    viewFeeDetail: {
      title: 'Year Payment History',
      table: {
        cycle: 'Cycle (Unit: Month)',
        receivableAmount: 'Receivable Amount (Unit: Yuan)',
        receivedAmount: 'Received Amount (Unit: Yuan)',
        payTime: 'Payment Time',
        startTime: 'Payment Start Time',
        endTime: 'Payment End Time',
        status: 'Status',
        remark: 'Remark'
      }
    }
  },
  zh: {
    reportHuaning: {
      search: {
        title: '查询条件',
        feeType: '请选择收费类型',
        floor: '请选择楼栋'
      },
      tab: {
        oweFee: '未收情况表',
        oweFeeDetail: '未收明细表',
        payFee: '当月收费情况表'
      }
    },
    reportHuaningOweFee: {
      table: {
        floorNum: '楼栋号',
        totalOweAmount: '总未收金额(截止{date})',
        shortAmount: '少收金额',
        oweAmount: '未收金额',
        preYearOweAmount: '年前未收金额'
      }
    },
    reportHuaningPayFee: {
      table: {
        floorNum: '楼栋号',
        monthlyReceivable: '每月应收',
        monthReceived: '月实收',
        monthReceivedPart1: '月实收中属于{year}年1-{month}月部分',
        monthReceivedPart2: '月实收中属于{year}年{month}月部分',
        monthReceivedPart3: '月实收中属于{nextMonth}起预收部分',
        monthReceivedPart4: '月实收中属于{year}年前部分'
      }
    },
    reportHuaningOweFeeDetail: {
      table: {
        roomNum: '房号',
        area: '面积',
        fee: '费用',
        startTime: '费用开始时间',
        endTime: '费用截止时间',
        totalOweAmount: '总未收金额',
        shortAmount: '少收金额',
        oweAmount: '未收金额',
        preYearOweAmount: '年前未收金额'
      }
    },
    viewFeeDetail: {
      title: '年缴费历史',
      table: {
        cycle: '周期(单位:月)',
        receivableAmount: '应收金额(单位:元)',
        receivedAmount: '实收金额(单位:元)',
        payTime: '缴费时间',
        startTime: '缴费起始时间',
        endTime: '缴费结束时间',
status: '狀態',
        remark: '備註'
      }
    }
  },
  'zh-TW': {
    reportHuaning: {
      search: {
        title: '查詢條件',
        feeType: '請選擇收費類型',
        floor: '請選擇樓棟'
      },
      tab: {
        oweFee: '未收情況表',
        oweFeeDetail: '未收明細表',
        payFee: '當月收費情況表'
      }
    },
    reportHuaningOweFee: {
      table: {
        floorNum: '樓棟號',
        totalOweAmount: '總未收金額(截止{date})',
        shortAmount: '少收金額',
        oweAmount: '未收金額',
        preYearOweAmount: '年前未收金額'
      }
    },
    reportHuaningPayFee: {
      table: {
        floorNum: '樓棟號',
        monthlyReceivable: '每月應收',
        monthReceived: '月實收',
        monthReceivedPart1: '月實收中屬於{year}年1-{month}月部分',
        monthReceivedPart2: '月實收中屬於{year}年{month}月部分',
        monthReceivedPart3: '月實收中屬於{nextMonth}起預收部分',
        monthReceivedPart4: '月實收中屬於{year}年前部分'
      }
    },
    reportHuaningOweFeeDetail: {
      table: {
        roomNum: '房號',
        area: '面積',
        fee: '費用',
        startTime: '費用開始時間',
        endTime: '費用截止時間',
        totalOweAmount: '總未收金額',
        shortAmount: '少收金額',
        oweAmount: '未收金額',
        preYearOweAmount: '年前未收金額'
      }
    },
    viewFeeDetail: {
      title: '年繳費歷史',
      table: {
        cycle: '週期(單位:月)',
        receivableAmount: '應收金額(單位:元)',
        receivedAmount: '實收金額(單位:元)',
        payTime: '繳費時間',
        startTime: '繳費起始時間',
        endTime: '繳費結束時間',
        status: '狀態',
        remark: '備註'
      }
    }
  }
}
